/**
 * 判断对象中的非null属性并返回key数组
 * @param lengthObj length对象
 * @returns 存在数据的length
 */
const getLength = (lengthObj) => {
    const arr = [];
    Object.keys(lengthObj).forEach((item) => {
        if (lengthObj[item])
            arr.push(item);
    });
    // 如果length为0的话返回undefined  为1的话返回length 是I型
    if (arr.length <= 1) {
        return arr[0];
    }
    return arr;
};
/**
 * 获取顶柜柜型及所在边
 * @param topjson 顶柜存在的时候的顶柜对象
 * @returns 顶柜柜型以及存在顶柜的边
 */
export const getTopCabinetLengthInfo = (topjson) => {
    if (!topjson) {
        return {
            type: null,
            length: [],
        };
    }
    if (!topjson) {
        return {
            type: null,
            length: [],
        };
    }
    const { type, length1, length2, length3, } = topjson;
    return {
        type,
        length: getLength({ length1, length2, length3 }),
    };
};
export const a = 1;
export const calloutLineFilter = (keyArr, calloutLineList) => calloutLineList === null || calloutLineList === void 0 ? void 0 : calloutLineList.filter((item) => keyArr.includes(item.type));
